import OwnerService from '../ownership/ownerService';
import AnimalClass from './animalClass';

export const identifier = 'animals';

export default class AnimalService<
    A extends AnimalClass
> extends OwnerService<A> {
    constructor(animalIdentifier?: string) {
        super(animalIdentifier || identifier, AnimalClass);
    }
}
